import Vue from 'vue';
import Vuex from 'vuex';

import configuration from './modules/configuration';
import scheduledTestDrives from './modules/scheduled-test-drives';
import otbcFlow from './modules/otbc/flow';
import otbcUser from './modules/otbc/user';
import rent from './modules/rent';

// @ts-ignore
Vue.use(Vuex);

const modules = {
  configuration,
  scheduledTestDrives,
  otbcFlow,
  otbcUser,
  rent,
};

export const storeConfig = {
  modules,
  state: {},
  mutations: {},
  getters: {},
  actions: {},
};

const store = new Vuex.Store(storeConfig as any);

(window as any).otbs = {
  ...(window.otbs || {}),
  state: store.state,
  getters: store.getters,
};

export default store;
